import { PageResponseVm } from "api/core/page-response.vm";
import { Type } from "class-transformer";
import { IsOptional, IsString, ValidateNested } from "class-validator";
import { TeamVm } from "./team.vm";

export class GetTeamsVm extends PageResponseVm<TeamVm, string> {
    @IsString()
    @IsOptional()
    nextOffset: string | null;

    @ValidateNested({ each: true })
    @Type(() => TeamVm)
    objects: TeamVm[];
}
